import React from "react";
import { ChevronDown } from "lucide-react";
import { Link, useLocation } from "react-router-dom";
import { useMenu } from "hooks/useMenu";

import { MENU_SIDEBAR } from "utils/menu.config";
import { cn } from "utils/cn";
import {
  Menubar,
  MenubarContent,
  MenubarItem,
  MenubarMenu,
  MenubarSub,
  MenubarSubContent,
  MenubarSubTrigger,
  MenubarTrigger,
} from "components/ui";
import checkAccess from "utils/checkAccess";

export function NavbarMenu() {
  const { pathname } = useLocation();
  // let navbarMenu = MENU_SIDEBAR?.[MENU_SIDEBAR.length - 1];

  const { isActive, hasActiveChild } = useMenu(pathname);

  const buildMenu = (items) => {
    return items
      ?.filter(
        (item) =>
          checkAccess(`${item?.action}_${item?.id}`) || item.id === "skip"
      )
      .map((item, index) => {
        if (item.children) {
          return (
            <MenubarMenu key={index}>
              <MenubarTrigger
                // className={cn(
                //   "flex items-center gap-1.5 px-3 py-3.5 text-sm text-foreground text-nowrap outline-transparent",
                //   "rounded-none border-b-2 border-transparent bg-none!",
                //   "hover:text-mono hover:bg-none",
                //   "focus:text-mono focus:bg-none",
                //   // "data-[state=open]:bg-transparent data-[state=open]:text-mono",
                //   "data-[here=true]:text-mono data-[here=true]:border-mono"
                // )}
                className={cn(
                  // "flex items-center gap-1.5 px-3 py-3.5 text-sm text-foreground text-nowrap outline-transparent",
                  // "rounded-none border-b-2 border-transparent",
                  // "bg-none! hover:bg-transparent focus:bg-transparent",
                  // "data-[state=open]:bg-transparent data-[state=open]:text-mono",
                  // "data-[active=true]:bg-transparent data-[active=true]:text-mono",
                  // "data-[here=true]:bg-transparent data-[here=true]:text-mono"
                  "flex items-center gap-1.5 px-3 py-3.5 text-sm text-foreground text-nowrap outline-transparent",
                  "rounded-none border-b-2 border-transparent outline-none",
                  "focus:text-mono focus:bg-transparent",
                  "data-[state=open]:bg-transparent data-[state=open]:text-mono",
                  "data-[here=true]:font-medium data-[here=true]:border-mono data-[here=true]:bg-transparent "
                )}
                data-active={isActive(item.path) || undefined}
                data-here={hasActiveChild(item.children) || undefined}
              >
                {item.title}
                <ChevronDown className="ms-auto size-3.5" />
              </MenubarTrigger>
              <MenubarContent className="min-w-[175px]" sideOffset={0}>
                {buildSubMenu(item.children)}
              </MenubarContent>
            </MenubarMenu>
          );
        } else {
          return (
            <MenubarMenu key={index}>
              <MenubarTrigger
                asChild
                className={cn(
                  // "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap outline-transparent",
                  // "rounded-none border-b-2 border-transparent bg-none!",
                  // "hover:text-mono hover:bg-none",
                  // "focus:text-mono focus:bg-none",
                  // "data-[state=open]:bg-transparent data-[state=open]:text-mono",
                  // "data-[active=true]:text-mono data-[active=true]:border-mono"
                  "flex text-sm text-foreground items-center px-2 py-3.5 px-3 text-nowrap  outline-transparent",
                  "rounded-none border-b-2 border-transparent bg-none! outline-none",
                  "firefox-hover:font-medium",
                  "focus:text-mono focus:bg-transparent",
                  "data-[state=open]:bg-transparent data-[state=open]:text-mono ",
                  "data-[active=true]:font-medium data-[active=true]:border-mono "
                )}
              >
                <Link
                  to={item.path || ""}
                  data-active={isActive(item.path) || undefined}
                  data-here={hasActiveChild(item.children) || undefined}
                >
                  {item.title}
                </Link>
              </MenubarTrigger>
            </MenubarMenu>
          );
        }
      });
  };

  const buildSubMenu = (items) => {
    return items
      ?.filter((item) => checkAccess(`${item?.action}_${item?.id}`))
      ?.map((item, index) => {
        if (item.children) {
          return (
            <MenubarSub key={index}>
              <MenubarSubTrigger
                data-active={isActive(item.path) || undefined}
                data-here={hasActiveChild(item.children) || undefined}
              >
                <span>{item.title}</span>
              </MenubarSubTrigger>
              <MenubarSubContent className="min-w-[175px]">
                {buildSubMenu(item.children)}
              </MenubarSubContent>
            </MenubarSub>
          );
        } else {
          return (
            <MenubarItem
              key={index}
              asChild
              data-active={isActive(item.path) || undefined}
              data-here={hasActiveChild(item.children) || undefined}
            >
              <Link to={item.path || ""}>{item.title}</Link>
            </MenubarItem>
          );
        }
      });
  };

  return (
    <div className="grid">
      <div className="kt-scrollable-x-auto">
        <Menubar className="flex items-stretch border-none bg-transparent p-0 h-auto">
          {buildMenu(MENU_SIDEBAR)}
        </Menubar>
      </div>
    </div>
  );
}
